import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';

import { GlobalFunctionsService } from '../../../services/global-functions.service';

@Component({
  selector: 'app-client-job-create',
  templateUrl: './client-job-create.component.html',
  styleUrls: ['./client-job-create.component.css']
})
export class ClientJobCreateComponent implements OnInit, OnDestroy, OnChanges {
  currentURL: string;
  client_brands: any;
  sessionBrandId: any;
  sessionUsername: any;
  sessionUserId: any;
  currentUserVAR: any;
  // a declared property

brandsMysql: any;

public nav: any;
public model;
// public today = Date.now();
public today = this.gfunc.todayDate;
public fee;
public trace;
public latest_trace_id;
public get_latest_trace_id;
public trace_id;
public trace_number_latest;
public get_trace_number_latest;
@Input() initialCount = 221;
@Input() count = this.initialCount;

// sees if there is a change in myCount
@Output() change: EventEmitter<number> = new EventEmitter<number>();
@Output() change2: EventEmitter<number> = new EventEmitter<number>();

myCount = 10;
job_types: any;
job_type_locations: any;
count2: any;
sent_job_type_location_id: any;
job_type_courts: any;
sent_job_type_court_id: any;
job_type_document_types: any;
sent_job_type_document_type_id: any;
job_type_affidavit_types: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  get_latest_job_id: any;
  latest_job_id: any;
  brands: any;
  brand_users: any;
  sent_brand_id: any;
  brand_report_selected: any;
  new_special_instuctions: any;
  selected_brand_data: any;
  report_type_id: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
     private route: ActivatedRoute, public toastr: HotToastService,
      vcr: ViewContainerRef, private router: Router,
      private gfunc: GlobalFunctionsService
  ) { 
    this.nav = document.querySelector('nav.navbar');
    

  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  }

  // New On Changes
  ngOnChanges() {
    this.change.emit(this.initialCount);
    this.model = new Job();
    // this.model = new BrandClientContact();
   // this.getBrandClientContacts.emit();
   // this.change2.emit(this.count2); // not required
  }


  ngOnInit() {
    this.nav.className += ' white-bg';


  this.model = new Job(); // loads the Trace model into the model vars for the form.
  new DatePipeComponent(); // prints out today | ect and formats time as a function
  this.getJobTypes(); // load the brands
  this.getJobTypeLocations(0); // loads default locations as nothing
  this.getBrands();
  }

  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }



  
// BOF SHARMANS CALLS
getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocations(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
     data => { this.job_type_locations = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeLocationsID(job_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count2 = job_type_id;
  this.getJobTypeLocations(this.count2); // updates the selected job ID....
  this.model.job_type_location_id = 1;
  this.model.job_type_court_id = 0;
  this.model.job_type_document_type_id = 0;
  this.model.job_type_affidavit_type_id = 0;

  // auto sets the client logged in for the job brand and report and invoice.
  this.model.brand_report_id = this.sessionBrandId;
  this.model.brand_invoice_id = this.sessionBrandId;

}


getJobTypeCourts(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
     data => { this.job_type_courts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeCourtsID(job_type_location_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_location_id = job_type_location_id;
  this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  this.model.job_type_court_id = 1;
  this.model.job_type_document_type_id = 0;
  this.model.job_type_affidavit_type_id = 0;


 console.log('sending Location:' + this.sent_job_type_location_id);
}


getJobTypeDocumentTypes(job_type_court_id) {
  this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
     data => { this.job_type_document_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeDocumentTypesID(job_type_court_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_court_id = job_type_court_id;
  this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  this.model.job_type_document_type_id = 1;
  this.model.job_type_affidavit_type_id = 0;

 console.log('sending Court Type:' + this.sent_job_type_court_id);
}


getJobTypeAffidavitTypes(job_type_document_type_id) {
  this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
     data => { this.job_type_affidavit_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeAffidavitTypesID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_document_type_id = job_type_document_type_id;
  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  this.model.job_type_affidavit_type_id = 1;
 console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}


/* 
getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 } */


 getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getClientContactsSharmans(client_id) {
  this._demoService.getClientContactsSharmans(client_id).subscribe(
     data => { this.client_contacts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 sendClientID(client_id) {
 this.sent_client_id = client_id;
 this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

 console.log('sending Client ID:' + this.sent_client_id);
}



getBrandUsers(brand_report_user_id) {
  this._demoService.getBrandUsers(brand_report_user_id).subscribe(
     data => { this.brand_users = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 sendBrandID(brand_report_user_id) {
 this.sent_brand_id = brand_report_user_id;
 this.getBrandUsers(this.sent_brand_id); // updates the selected job ID....
// need to look up what brands notes are and send to jon notes.
// lookup brand
// set this.model.special_instuctions.
this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function

 //console.log('sending Brand ID:' + this.sent_brand_id);
}





createJobTesting(model) {
 // this.router.navigate(['/admin/jobs/create-job-2/' + model.client_id + '']);
  // set the defaults.
  model.created_by = this.gfunc.sessionUserId;
  model.updated_by = this.gfunc.sessionUserId;
  model.status = 'PENDING';
  model.job_status_code = 'PENDING'; // Set to pending for a client submission.

  model.created_date = this.gfunc.today;

  this._demoService.createJob(model).subscribe(
     data => {   this.get_latest_job_id = data; // this is the retuned json upon creation.
     this.toastr.success('New Job Project Saving...' + this.get_latest_job_id.last_insert_id + '');
     // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
     this.latest_job_id = this.get_latest_job_id.last_insert_id;

      // Setup annd the Currents before we redirec the page
      // Needs to be a Function to update the ObserveOnOperator.
      // this.newCTrace_id(this.latest_trace_id);
      // or this.cdata.changeCTrace_id("999");

      model.job_id = this.latest_job_id;
      // insert log
      this.gfunc.insertLog_CreateJob(model);

      this.router.navigate(['/client/jobs/create-job-step-2/' + this.latest_job_id + '']);

        return true;


     },
     error => {
     // console.log('Should be form Model' + model);
     // console.error('Error Creating a Trace Project!');
       this.toastr.error('Adding Job Failed :: Please try again!');
      //  console.log(Observable.throw(error));
      return console.log(error);
     }
);
}


getBrandById_instructions(brand_id){
  this._demoService. getBrandById(brand_id)
  .subscribe(
    res => {this.brand_report_selected = res;
      this.selected_brand_data = res[0];
     this.new_special_instuctions = this.selected_brand_data.brand_notes;
     this.model.special_instructions = this.new_special_instuctions;
     // console.log('instuctions: ' + this.new_special_instuctions);
   
    },
    err => console.error(err.status)
  );
 }

} // end component




  // Allows formatting of dates etc...
  export class DatePipeComponent {
    today: number = Date.now();
    fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
  }

